<template>
  <div class="menu" :class="{ 'menu-open': isOpen }">
    <br><br>
    <div>
      <ul>

        <li> <router-link to="/demo"> Home</router-link> </li>
        <li> <router-link to="/Pools-Page"> Search Pools</router-link> </li>
       
        <li> <router-link to="/Notification-Page"> Notifications </router-link> </li>
        
        
      
        <li> <router-link to="/User-Submissions"> User Submissions </router-link> </li>
        <li> <router-link to="/Bug-Report"> Report Bugs </router-link> </li>
        <li> <router-link to="/User-Profile"> User Profile </router-link> </li>
       

      </ul>
    </div>
  </div>
  <div class="pageOpen">
  <router-view></router-view>
</div>
</template>
  
<script>
export default{
  props: {
    isOpen: Boolean
  } 
}
</script>
  
<style scoped>
.menu {
  position: fixed;
  top: 0;
  left: -300px;
  width: 300px;
  height: 100%;
  background-color: #f1f1f1;
  transition: left 0.3s ease-in-out;
  z-index: 998;
}

.menu-open {
  left: 0;
}

ul {
  list-style-type: none;
  padding: 0;
  
}

li {
  padding: 20px;
  border-bottom: 1px solid #ddd;
  cursor: pointer;
  text-decoration: none;
}

li:hover {
  background-color: #ddd;
}

.pageOpen {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 50px;

  /* Additional styles for the container if needed */
}

</style>
  